export default __webpack_public_path__ + "static/media/pexels-pavel-danilyuk-5495783.6e5be836.mp4";